import { AnalyticsBrowser } from '@segment/analytics-next';
import { of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

import { throwClientLoadingError } from '@core/analytics-types';
import type {
  SegmentAPIMethods,
  SegmentClientIdentifyCallbackFn,
  SegmentClientOptions,
} from '@core/analytics-types';

export const loadAnalytics = (segmentKey: string, options?: SegmentClientOptions) => {
  const client = AnalyticsBrowser.load({ writeKey: segmentKey }, options);
  return of(segmentAdapter(client)).pipe(
    catchError(() => throwClientLoadingError()),
    tap((_client: any) => {
      _client.addDestinationMiddleware('Intercom', ({ payload, next }: any) => {
        const type = payload.obj.type;

        if (type === 'identify') {
          /**
           * This part ensures that we always send `email` and not `id` field preferred by default by Intercom
           * We mutate instead of creating the new object as described in Segment docs:
           * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/#using-destination-middlewares
           */

          delete payload.obj.traits.id;
          delete payload.obj.id;
          delete payload.obj.userId;

          payload.obj.email = payload.obj.traits.email;
        }

        next(payload);
      });
    }),
    shareReplay(1),
  );
};
const segmentAdapter = (input: AnalyticsBrowser): SegmentAPIMethods => ({
  ...input,
  identify: (
    userId?: number,
    traits?: Record<string, string | number>,
    options?: SegmentClientOptions,
    callback?: SegmentClientIdentifyCallbackFn,
  ) => {
    input.identify(`${userId}`, traits, options, callback);
  },
});
